import i18n from '@/js/plugins/i18n';
import constants from '@/js/constants.js';

const VueI18n = i18n.global;

export default {
  timelineOptions: () => [
    { value: 'years', title: VueI18n.t('TIMELINE.YEARS') },
    { value: 'quarters', title: VueI18n.t('TIMELINE.QUARTERS') },
    { value: 'months', title: VueI18n.t('TIMELINE.MONTHS') },
    { value: 'weeks', title: VueI18n.t('TIMELINE.WEEKS') },
    { value: 'days', title: VueI18n.t('TIMELINE.DAYS') },
    { value: 'none', title: VueI18n.t('TIMELINE.NONE') },
  ],
  availableColWidthOptions: () => [
    { value: 300, title: VueI18n.t('TIMELINE.X-LARGE') },
    { value: 230, title: VueI18n.t('TIMELINE.LARGE') },
    { value: 160, title: VueI18n.t('TIMELINE.MEDIUM') },
    { value: 100, title: VueI18n.t('TIMELINE.SMALL') },
    { value: 50, title: VueI18n.t('TIMELINE.X-SMALL') },
  ],
  availablePrivacyOptions: () => [
    { value: 'company', title: `${VueI18n.t('ACR.COMPANY')[0].toUpperCase()}${VueI18n.t('ACR.COMPANY').slice(1)}`, icon: 'far fa-pencil-alt' },
    { value: 'company visible', title: `${VueI18n.t('ACR.COMPANY_VISIBLE')[0].toUpperCase()}${VueI18n.t('ACR.COMPANY_VISIBLE').slice(1)}`, icon: 'far fa-eye' },
    { value: 'private', title: `${VueI18n.t('ACR.PRIVATE')[0].toUpperCase()}${VueI18n.t('ACR.PRIVATE').slice(1)}`, icon: 'far fa-lock' },
  ],
  processSteps: () => [ // mode kanban
    { id: null, label: VueI18n.t('KANBAN.BACKLOG'), color: 5, width: 1.5 * constants.kanbanDefaultColWidth },
    { id: window.uuid(), label: VueI18n.t('KANBAN.INPROGRESS'), color: 4, icon: 'sync', width: constants.kanbanDefaultColWidth },
    { id: window.uuid(), label: VueI18n.t('KANBAN.DONE'), color: 1, icon: 'endflag', width: constants.kanbanDefaultColWidth },
    { id: window.uuid(), label: VueI18n.t('KANBAN.VALIDATED'), color: 2, icon: 'done', width: constants.kanbanDefaultColWidth },
  ],
  projectStatus() {
    return {
      consolidation: {
        label: VueI18n.t('PROJECTS.STATUS.CONSOLIDATIONS'),
        readonly: false,
        nodashboards: true,
        template: false,
      },
      template: {
        label: VueI18n.t('PROJECTS.STATUS.TEMPLATES'),
        readonly: true,
        nodashboards: true,
        template: true,
      },
      draft: {
        label: VueI18n.t('PROJECTS.STATUS.DRAFTS'),
        readonly: false,
        nodashboards: true,
        template: false,
      },
      completed: {
        label: VueI18n.t('PROJECTS.STATUS.COMPLETED'),
        readonly: true,
        nodashboards: false,
        template: false,
      },
    };
  },
  budgetStates() {
    return {
      draft: VueI18n.t('ELEMENT-DETAIL.DRAFT'),
      quotation: VueI18n.t('ELEMENT-DETAIL.QUOTATION'),
      charged: VueI18n.t('ELEMENT-DETAIL.CHARGED'),
      paid: VueI18n.t('ELEMENT-DETAIL.PAID'),
    };
  },
  timelineFormats() {
    function generateFormats(Q = 'Q', W = 'W', separator = '-') {
      return {
        years: [
          { xs: 'YYYY', s: 'YYYY', m: 'YYYY', l: 'YYYY' },
        ],
        quarters: [
          { xs: `[${Q}]Q`, s: `[${Q}]Q YYYY`, m: `[${Q}]Q YYYY`, l: `[${Q}]Q YYYY` }, // timeline
          { xs: `[${Q}]Q`, s: `[${Q}]Q`, m: `[${Q}]Q`, l: `[${Q}]Q YYYY` }, // subtimeline
        ],
        months: [
          { xs: 'MMM', s: 'MMM YYYY', m: 'MMM YYYY', l: 'MMMM YYYY' },
          { xs: 'MMM', s: 'MMMM', m: 'MMMM', l: 'MMMM YYYY' },
        ],
        weeks: [
          { xs: `[${W}]w`, s: `[${W}]w`, m: `[${W}]w YYYY`, l: `[${W}]w YYYY` },
          { xs: `[${W}]w`, s: `[${W}]w`, m: `[${W}]w - DD${separator}MM`, l: `[${W}]w - DD${separator}MM${separator}YYYY` },
        ],
        days: [
          { xs: `DD${separator}MM`, s: `dd DD${separator}MM`, m: `dd DD${separator}MM`, l: `dd DD${separator}MM${separator}YYYY` },
          { xs: `dd DD`, s: `dd DD${separator}MM`, m: `dd DD${separator}MM`, l: `dd DD${separator}MM${separator}YYYY` },
        ],
      };
    }

    return {
      en: generateFormats('Q', 'W', '-'),
      fr: generateFormats('T', 'S', '/'),
    };
  },
};
